
const sellerDashboard = {
  namespaced: true,
  state: {
    tabSelected: 0,
  },

  actions: {
    selectTab({ commit }, payload) {
      commit("SELECT_TAB", payload);
    },
  },
  mutations: {
    SELECT_TAB: (state, payload) => {
      state.tabSelected = payload;
    },
  },
  getters: {
    getTabSelected(state) {
      return state.tabSelected;
    },
    isSpotTab(state) {
      return state.tabSelected.type === "Spot";
    },
    isContractsTab(state) {
      return state.tabSelected.type === "Contracts";
    },
    isDeliveredInTab(state) {
      return state.tabSelected.type === "Delivered In";
    },
  },
};



export default sellerDashboard